import SpriteSymbol from "../../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/_svg-sprite-loader@6.0.9@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "sensitive_info",
  "use": "sensitive_info-usage",
  "viewBox": "0 0 14 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 16\" id=\"sensitive_info\"><g fill-rule=\"evenodd\"><path d=\"M0 16h14V0H0v16zM1.885 1h10.379L9.292 4H4.811L1.885 1zM1 1.523L4.389 5h5.319L13 1.68V15H1V1.523z\" /><path d=\"M6 11h2l.216-5H5.761zM6 14h2v-2H6z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id